import { createSlice } from "@reduxjs/toolkit";
import { careersAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const careersSlice = createSlice({
  name: "careers",
  initialState: data,
  reducers: {
    careersSlice(state) {
      state.isLoading = false;
    },
    careersSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    careersSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    careersSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const careersHandler = () => async (dispatch: any) => {
  try {
    dispatch(careersAction.careersSlice());
    const response: any = await careersAPI();
    dispatch(careersAction.careersSliceSuccess(response));
  } catch (e: any) {
    dispatch(careersAction.careersSliceFailure(e?.response?.data?.message));
    dispatch(careersAction.careersSliceReset());
  }
};
export default careersSlice.reducer;
export const careersAction = careersSlice.actions;
